
const Urls = {
    SERVER: 'https://admin.ccsaalumni.in/api/',
    IMAGE: 'https://admin.ccsaalumni.in/storage/',

    // SERVER: 'http://127.0.0.1:8000/api/',
    // SERVER: 'http://localhost/alumni_sys/public/api/',
    // IMAGE: 'http://localhost/alumni_sys/public/storage/',

    // Login related urls
    SEND_OTP: 'sendotp',
    VERIFY_OTP: 'verify-otp',
    REGISTER: 'register',
    LOGIN: 'login',

    // User Urls
    HOME: "home",
    GET_EVENT_BY_ID: "event",
    GET_ALL_EVENTS: "all-events",
    GET_DASHBOARD: "dashboard",
    REGISTER_ALUMNI: "register-alumni",
    GET_ALUMNI_REGISTRATION: "alumni-registration",
    GET_COURSES: "get-courses",
    UPLOAD_IMAGE: "upload-image",
    UPDATE_PROFILE_IMAGE: "update-profile-image",
    CHECK_PAYMENT: "check-payment",
    GET_ALUMNI_ID: "get-alumni-id",
    GET_PROFILE_DETAILS: "profile",
    ADD_COURSE: "add-course",
    REMOVE_COURSE: "remove-course",
    ADD_HIGHER_EDUCATION: "add-higher-education",
    ADD_OCCUPATION: "add-occupation",
    REMOVE_HIGHER_EDUCATION: "remove-higher-education",
    REMOVE_OCCUPATION: "remove-occupation",
    ADD_SOCIAL_HANDLE: "add-social-handle",
    REMOVE_SOCIAL_HANDLE: "remove-social-handle",
    SETTINGS: "settings",
    NOTIFICATIONS: "notifications",
    GET_ALL_ALUMNI: "all-alumni",
    GET_ALUMNI_BY_ID: "get-alumni-by-id",
    GET_CONTRIBUTIONS: "get-contributions",
    GET_ALL_NOTIFICATIONS: "all-notifications",
    SEARCH_ALUMNI: "search-alumni",
    GET_TESTIMONY: "get-testimonial",
    ADD_TESTIMONY: "add-testimonial",
    DELETE_TESTIMONY: "delete-testimonial",
    UPDATE_EMAIL_AND_PHONE: "update-email-and-phone",

    //local routes 
    DASHBOARD: "user/dashboard",




}

export default Urls;